import { render, staticRenderFns } from "./users.vue?vue&type=template&id=f4bc0314"
import script from "./users.ts?vue&type=script&lang=ts&external"
export * from "./users.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports